import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { DashboardIndexComponent } from './components/inside/dashboard/dashboard-index/dashboard-index.component';
import { RouterModule } from '@angular/router';
import { AuthInterceptorService } from './services/auth-interceptor/auth-interceptor.service';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { LottieModule } from '@synapsium/ngx-lottie';
import { InsideComponent } from './components/inside/inside.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SidebarComponent } from './components/utils/sidebar/sidebar.component';
import { NavigatorComponent } from './components/utils/navigator/navigator.component';
import { LoginComponent } from './components/login/login.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RecoverComponent } from './components/recover/recover.component';
import { PaginatorComponent } from './components/utils/paginator/paginator.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { LoadingComponent } from './components/utils/loading/loading.component';
import { ReversePipe } from './components/utils/pipe/reverse.pipe';
import { ChangePswComponent } from './components/change-psw/change-psw.component';
import { ConfirmModalComponent } from './components/utils/confirm-modal/confirm-modal.component';
import { MultiSelectComponent } from './components/utils/multi-select/multi-select.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { SelectComponent } from './components/utils/select/select.component';
import { NavbarComponent } from './components/utils/navbar/navbar.component';
import { InvoicesComponent } from './components/inside/invoices/invoices.component';
import { UsersComponent } from './components/inside/users/users.component';
import { ConfigurationComponent } from './components/inside/configuration/configuration.component';
import { StatsComponent } from './components/inside/stats/stats.component';
import { ActiveInvoicesComponent } from './components/inside/invoices/active-invoices/active-invoices.component';
import { PassiveInvoicesComponent } from './components/inside/invoices/passive-invoices/passive-invoices.component';
import { EstereInvoicesComponent } from './components/inside/invoices/estere-invoices/estere-invoices.component';
import { AdvancedSearchComponent } from './components/utils/advanced-search/advanced-search.component';
import { RubricaComponent } from './components/inside/configuration/rubrica/rubrica.component';
import { SectionalsComponent } from './components/inside/configuration/sectionals/sectionals.component';
import { ItemsComponent } from './components/inside/configuration/items/items.component';
import { LabelsComponent } from './components/inside/configuration/labels/labels.component';
import { ConfDashboardComponent } from './components/inside/configuration/conf-dashboard/conf-dashboard.component';
import { UserEditorComponent } from './components/inside/users/user-editor/user-editor.component';
import { PersonalDataComponent } from './components/inside/users/user-editor/personal-data/personal-data.component';
import { RubricaEditorComponent } from './components/inside/configuration/rubrica/rubrica-editor/rubrica-editor.component';
import { ClickOutsideModule } from 'ng-click-outside';
import { EditorInvoiceComponent } from './components/inside/invoices/editor-invoice/editor-invoice.component';
import { SoggettiComponent } from './components/inside/invoices/editor-invoice/soggetti/soggetti.component';
import { DatiDocumentoComponent } from './components/inside/invoices/editor-invoice/dati-documento/dati-documento.component';
import { DatiRitenutaCassaScontiComponent } from './components/inside/invoices/editor-invoice/dati-ritenuta-cassa-sconti/dati-ritenuta-cassa-sconti.component';
import { DocumentiCorrelatiComponent } from './components/inside/invoices/editor-invoice/documenti-correlati/documenti-correlati.component';
import { DatiBeniServiziComponent } from './components/inside/invoices/editor-invoice/dati-beni-servizi/dati-beni-servizi.component';
import { DatiPagamentoComponent } from './components/inside/invoices/editor-invoice/dati-pagamento/dati-pagamento.component';
import { AllegatiComponent } from './components/inside/invoices/editor-invoice/allegati/allegati.component';
import { RicercaIndirizzoComponent } from './components/inside/invoices/editor-invoice/dialog/ricerca-indirizzo/ricerca-indirizzo.component';
import { SezionaliDisponibiliComponent } from './components/inside/invoices/editor-invoice/dialog/sezionali-disponibili/sezionali-disponibili.component';
import { ArticoliDisponibiliComponent } from './components/inside/invoices/editor-invoice/dialog/articoli-disponibili/articoli-disponibili.component';
import { InfoDettaglioLineeComponent } from './components/inside/invoices/editor-invoice/dialog/info-dettaglio-linee/info-dettaglio-linee.component';
import { DatiTrasportoComponent } from './components/inside/invoices/editor-invoice/dati-trasporto/dati-trasporto.component';
import { InfoDatoPagamentoComponent } from './components/inside/invoices/editor-invoice/dialog/info-dato-pagamento/info-dato-pagamento.component';
import { BarraRiepilogoComponent } from './components/inside/invoices/editor-invoice/barra-riepilogo/barra-riepilogo.component';
import { SessionCountdownComponent } from './components/utils/session-countdown/session-countdown.component';
import { ToastComponent } from './components/inside/utils/toast/toast.component';
import { SmartFloatDirective } from './directive/smart-float/smart-float.directive';
import { PreviewModalComponent } from './components/utils/preview-modal/preview-modal.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { EmailModalComponent } from './components/inside/invoices/active-invoices/email-modal/email-modal.component';
import { ItemComponent } from './components/utils/advanced-search/item/item.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ChangePwModalComponent } from './components/profile/change-pw-modal/change-pw-modal.component';
import { CapitalizeButtonDirective } from './directive/capitalizeButton/capitalize-button.directive';
import { CompanyModalComponent } from './components/inside/users/user-editor/company-modal/company-modal.component';
import { RicercaAziendaComponent } from './components/inside/users/user-editor/ricerca-azienda/ricerca-azienda.component';
import { AppConfig } from './app.config';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { ItalianDateParserFormatter } from './datepicker-adapter';
registerLocaleData(localeIt);

import { AngularEditorModule } from '@kolkov/angular-editor';
import { RicercaRivenditoriComponent } from './components/inside/configuration/conf-dashboard/ricerca-rivenditori/ricerca-rivenditori.component';
import { ChartsModule } from 'ng2-charts';
import { GraficiComponent } from './components/inside/dashboard/grafici/grafici.component';
import { IbanAggiuntiviComponent } from './components/inside/invoices/editor-invoice/dialog/iban-aggiuntivi/iban-aggiuntivi.component';
import { EsitaModalComponent } from './components/utils/esita-modal/esita-modal.component';
import { ChangeLogModalComponent } from './components/utils/change-log-modal/change-log-modal.component';

// @ts-ignore
import packageInfo from '../../package.json';
import { SoggettiDestinatarioComponent } from './components/inside/invoices/editor-invoice/soggetti/soggetti-destinatario/soggetti-destinatario.component';
import { RegimeFiscalePipe } from './components/utils/pipe/regime-fiscale.pipe';
import { RegistrazioneComponent } from './components/registrazione/registrazione.component';
import { OptimaSmartComponent } from './components/inside/optima-smart/optima-smart.component';
import { NsoInvoicesComponent } from './components/inside/invoices/nso-invoices/nso-invoices.component';

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardIndexComponent,
    NotFoundComponent,
    InsideComponent,
    SidebarComponent,
    NavigatorComponent,
    RecoverComponent,
    PaginatorComponent,
    LoadingComponent,
    ReversePipe,
    ChangePswComponent,
    ConfirmModalComponent,
    MultiSelectComponent,
    SelectComponent,
    NavbarComponent,
    InvoicesComponent,
    UsersComponent,
    ConfigurationComponent,
    StatsComponent,
    ActiveInvoicesComponent,
    PassiveInvoicesComponent,
    EstereInvoicesComponent,
    AdvancedSearchComponent,
    StatsComponent,
    RubricaComponent,
    SectionalsComponent,
    ItemsComponent,
    LabelsComponent,
    ConfDashboardComponent,
    UserEditorComponent,
    PersonalDataComponent,
    RubricaEditorComponent,
    PersonalDataComponent,
    EditorInvoiceComponent,
    SoggettiComponent,
    DatiDocumentoComponent,
    DocumentiCorrelatiComponent,
    DatiBeniServiziComponent,
    DatiRitenutaCassaScontiComponent,
    DatiPagamentoComponent,
    AllegatiComponent,
    RicercaIndirizzoComponent,
    SezionaliDisponibiliComponent,
    ArticoliDisponibiliComponent,
    InfoDettaglioLineeComponent,
    DatiTrasportoComponent,
    InfoDatoPagamentoComponent,
    BarraRiepilogoComponent,
    SessionCountdownComponent,
    ToastComponent,
    SmartFloatDirective,
    PreviewModalComponent,
    EmailModalComponent,
    ItemComponent,
    ProfileComponent,
    ChangePwModalComponent,
    CompanyModalComponent,
    RicercaAziendaComponent,
    RicercaRivenditoriComponent,
    CapitalizeButtonDirective,
    GraficiComponent,
    IbanAggiuntiviComponent,
    EsitaModalComponent,
    ChangeLogModalComponent,
    SoggettiDestinatarioComponent,
    RegimeFiscalePipe,
    RegistrazioneComponent,
    OptimaSmartComponent,
    NsoInvoicesComponent
  ],
  imports: [
    BrowserModule,
    ClickOutsideModule,
    AppRoutingModule, 
    FormsModule,
    NgSelectModule,
    HttpClientModule,
    RouterModule,
    PdfViewerModule,
    LottieModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    NgbModule,
    DragDropModule,
    AngularEditorModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),
    ChartsModule
  ],
  providers: [
    //CookieService,
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig], multi: true
    },
    {
    provide : HTTP_INTERCEPTORS,
    useClass : AuthInterceptorService,
    multi: true
  },
  DatePipe,
  { provide: LOCALE_ID, useValue: "it-IT"},
  { provide: NgbDateParserFormatter, useClass: ItalianDateParserFormatter }],
  bootstrap: [AppComponent]
})
export class AppModule { 
  appVersion: string;

    public constructor() {
        this.appVersion = packageInfo.version;
        if (localStorage.getItem('APP_VERSION') !== this.appVersion) {
            localStorage.setItem('APP_VERSION', this.appVersion);
            window.location.reload();
        }

    }
}


export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
